import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import useInput from "../hooks/useInput";
import axios from "../api/axios";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Messages } from "primereact/messages";
// import { StyleClass } from 'primereact/styleclass';
import { Image } from 'primereact/image';
const LOGIN_URL = "/C4-Nicaragua/login";

const Login = () => {
  const { setAuth, persist, setPersist } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const emailRef = useRef();
  const errRef = useRef();
  const [email, resetEmail, userAttribs] = useInput("email", "");
  const [password, setPwd] = useState("");
  const auth = useAuth();
  const msgs = useRef(null);

  useEffect(() => {
    emailRef.current.focus();
  }, []);

  useEffect(() => {}, [email, password]);
  const handleSubmit = async (e) => {
    msgs.current.clear();
    e.preventDefault();

    try {
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ email, password }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      console.log(JSON.stringify(response?.data));

      const nombre = response?.data?.nombre;
      const Parametros = response?.data?.Parametros;
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      
      setAuth({ nombre, email, password, roles, accessToken, Parametros });
      resetEmail();
      setPwd("");
      console.log(auth);
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        msgs.current.show([
          {
            sticky: true,
            severity: "error",
            summary: "Error",
            detail: "No Server Response",
          },
        ]);
      } else if (err.response?.status === 400) {
        msgs.current.show([
          {
            sticky: true,
            severity: "error",
            summary: "Error",
            detail: "Missing Username or Password",
          },
        ]);
      } else if (err.response?.status === 401) {
        msgs.current.show([
          {
            sticky: true,
            severity: "error",
            summary: "Error",
            detail: "Unauthorized",
          },
        ]);
      } else {
        msgs.current.show([
          {
            sticky: true,
            severity: "error",
            summary: "Error",
            detail: "Login Failed",
          },
        ]);
      }
      errRef.current.focus();
    }
  };
  const togglePersist = () => {
    setPersist((prev) => !prev);
  };
  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist]);

  return (
    <>
      <Messages ref={msgs} />
      <div style={{ width: '80%', paddingRight: '.85rem', paddingLeft: '.85rem' }}>
        
        <div className="grid">

        <div className="login-container">
        <div className="col ">          
        {/* <div className="card flex justify-content-center"> C4_Nicaragua_Logo_ */}
            <Image src="/images/C4_Nicaragua_Logo_.png"  width="120" />   
          
        </div>
        <div className="login-box">
          <h2>Inicio de sesión</h2>
          <form className="login-form" onSubmit={handleSubmit}>
            <label>Correo electronico</label>
            <InputText
              className="input-field"
              id="username"
              ref={emailRef}
              autoComplete="off"
              {...userAttribs}
              required
            />
            <label>Contraseña</label>
            <Password
              feedback={false}
              toggleMask
              className="input-field"
              id="password"
              onChange={(e) => setPwd(e.target.value)}
              value={password}
              required
            />
            <div className="login-options">
              <Checkbox
                inputId="persist"
                id="persist"
                onChange={togglePersist}
                checked={persist}
              />
              <label htmlFor="terms" className="ml-2">
                Mantener la sesion iniciada
              </label>
            </div>
            <Button label="Ingresar" className="login-button" />
          </form>
        </div>
        </div>
        </div>
        
      </div>
    </>
  );
};
export default Login;
